import { colors } from '@material-ui/core'

const buildGradient = (start, end) => `linear-gradient(180deg, ${start} 0%, ${end} 100%)`

const grey = buildGradient(colors.grey[400], colors.grey[600])
const blue = buildGradient(colors.blue[700], colors.blue[900])
const dourado = buildGradient('#EEAD2D', '#FFBF00')
const indigo = buildGradient(colors.indigo[400], colors.indigo[600])
const green = buildGradient('#30B59E', '#205C59')
const styledYellow = buildGradient('#a2d448', '#81b845')
const styledPurple = buildGradient('#6b47bd', '#3f3b85')
const orange = buildGradient(colors.orange[400], colors.orange[900])
const red = buildGradient(colors.red[500], colors.red[700])

export default {
  grey,
  blue,
  indigo,
  green,
  orange,
  red,
  styledYellow,
  styledPurple,
  dourado,
}
